interface GameInviteExistingConfirmProps {
  onReplace: () => void;
  onKeep: () => void;
}

export default function GameInviteExistingConfirm({
  onReplace,
  onKeep,
}: GameInviteExistingConfirmProps) {
  return (
    <div className="modal-overlay" onClick={onKeep}>
      <div
        className="modal-content game-invite-offline-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="game-invite-existing-title"
      >
        <div className="modal-header">
          <h2 id="game-invite-existing-title">Invitation déjà en cours</h2>
          <button type="button" className="modal-close" onClick={onKeep} aria-label="Fermer">
            ×
          </button>
        </div>
        <div className="game-invite-offline-body">
          <p>
            Une invitation à jouer est déjà active dans cette conversation, avec une table
            toujours en préparation.
          </p>
          <p>
            Souhaitez-vous annuler cette invitation pour en lancer une nouvelle, ou garder
            l'invitation actuelle ?
          </p>
        </div>
        <div className="game-invite-offline-actions">
          <button type="button" className="game-invite-offline-btn secondary" onClick={onKeep}>
            Garder l'invitation actuelle
          </button>
          <button type="button" className="game-invite-offline-btn primary" onClick={onReplace}>
            Annuler et en envoyer une nouvelle
          </button>
        </div>
      </div>
    </div>
  );
}
